// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mini-reason-for-change .el-dialog {\n  width: 28%;\n  height: 210px !important;\n  margin-top: 20vh;\n}", ""]);
// Exports
module.exports = exports;
